import { useCallback, useState } from 'react';
const useIsOpen = (defaultIsOpen) => {
    const [isOpen, setIsOpen] = useState(defaultIsOpen ?? false);
    const open = useCallback(() => {
        setIsOpen(true);
    }, []);
    const close = useCallback(() => {
        setIsOpen(false);
    }, []);
    const toggle = useCallback(() => {
        setIsOpen((prevState) => !prevState);
    }, []);
    return { isOpen, toggle, open, close };
};
export { useIsOpen };
//# sourceMappingURL=useIsOpen.js.map